/** TT Wallet 會把帳號改成小寫字母!! */
export default function isSameAddress(a?: any, b?: any): boolean {
  return typeof a === 'string'
    && typeof b === 'string'
    && a.trim().toLowerCase() === b.trim().toLowerCase()
}
